<script setup>
// store
const store = useLoginStore()

// login
const login = async () => {
  if (!store.needDatabase) {
    if (!await store.loadDomains()) store.showError('Domains konnten nicht geladen werden.')
  }
  store.processing = true
}
// Transform username to uppercase before storing
const updateUsername = (event) => {
  store.user.username = event.target.value.toUpperCase()
}
</script>

<template>
  <form @submit.prevent="login">
    <div class="row row-cols-1 gy-3 px-3">
      <div class="col">
        <div class="form-group has-icon">
          <span class="text-secondary form-icon">
            <i class="fas fa-user" />
          </span>
          <InputText
            v-model="store.user.username"
            class="form-control form-control-lg text-secondary bg-white col-12"
            style="text-transform: uppercase;"
            type="text"
            placeholder="Username"
            required
            autofocus
            autocomplete="on"
            autocapitalize="on"
            @input="updateUsername"
          />
        </div>
      </div>
      <div class="col">
        <div class="form-group has-icon">
          <span class="text-secondary form-icon">
            <i class="fas fa-key" />
          </span>
          <InputText
            v-model="store.user.password"
            class="form-control form-control-lg text-secondary bg-white col-12"
            style="text-transform: uppercase;"
            type="password"
            placeholder="Password"
            required
            autofocus
            autocomplete="on"
            autocapitalize="on"
          />
        </div>
      </div>
      <div class="col">
        <Button
          type="submit"
          class="btn btn-primary btn-block btn-lg w-100"
          label="Login"
          :loading="store.processing"
        />
      </div>
    </div>
  </form>
</template>
